export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',
	ARTISTS = 'artists',
	GALLERIES = 'galleries',

	CONTENT = 'content',
	TAGS = 'tags',
}
